import type { WPPostListProps } from '@ria-client/supergraph/structuredContent/hydration/WPPostList/index';
import { ChevronRight } from 'lucide-react';
import type { NodeProps } from '../types';
import { ContentLink } from './lib/content-link';
import { NextStepsCards } from './lib/next-steps-cards';

/**
 * `WPPostList` with posts resolved server-side (supergraph WPPostList hydration). Article rails use
 * `chevron-list` and article NextSteps use `next-steps`; other templates render nothing.
 * Source: NerdWallet/structured-content shared-core/src/components/post-list/templates/chevron-list.
 */
export function WPPostList({ props }: NodeProps<WPPostListProps & Record<string, unknown>>) {
  if (!props.items?.length) return null;
  if (props.template === 'next-steps') return <NextStepsCards items={props.items} />;
  if (props.template !== 'chevron-list') return null;

  return (
    <ul className="flex flex-col gap-2">
      {props.items.map(item => (
        <li key={item.id}>
          <ContentLink
            className="group flex items-center gap-2 font-sans font-medium text-secondary-foreground no-underline hover:no-underline"
            href={item.url ?? undefined}
          >
            {/* 6px nudge: legacy chevron-list-item.module.less hover `left: 6px`. */}
            <ChevronRight
              aria-hidden="true"
              className="size-3.5 relative shrink-0 transition-transform duration-200 ease-in-out group-hover:translate-x-1.5"
            />
            {/* 13px: legacy Text size="small" bold; Theme/index.ts bodySmall fontSize, no scale match. */}
            <span className="text-[0.8125rem]">{item.title}</span>
          </ContentLink>
        </li>
      ))}
    </ul>
  );
}
